import services from '../services/api';
import config from '../config';

// apiv2 envia o cookie de sessao do cliente (o userId vem da sessao na API)
const axios = services.apiv2;

const BASE_URL = `${config.endpointv2}terms-of-use`;
const getTermsOfUse = () => {
  return axios.get(BASE_URL);
};
const replyTermsOfUse = (data) => {
  return axios.post(`${BASE_URL}`, data);
};

export const termsOfUseRepository = {
  getTermsOfUse,
  replyTermsOfUse
};
